import { Container } from '../../pages/Home/styles';

export default function Home() {
  return (
    <Container>
    </Container>
  )
}